module.exports = __webpack_public_path__ + "img/i_vacation.3d309515.png";